import { Entry } from 'contentful'
import { IPage } from 'marketing-site/@types/generated/contentful'
import { renderBodyContent } from 'marketing-site/lib/render'
import React from 'react'

export function isGenericPage(entry: Entry<any>): entry is IPage {
  return entry.sys.contentType?.sys.id === 'page'
}

export function GenericPage(page: IPage): React.ReactElement {
  const { bodyContent } = page.fields

  return <>{renderBodyContent(bodyContent)}</>
}
